// -----------------------------------------------------------------------------------------------------
// @ Constantes Globales
// -----------------------------------------------------------------------------------------------------

/**
 * @constant
 * @desc Dirección para verificar sí el plugin fue activado
 */
export const PLUGIN_PATH: string = 'http://localhost:40589/';

/**
 * @constant
 * @desc Versión de fireware del proyecto
 */
export const VERSION_FIREWARE = '01.01';

/**
 * @constant
 * @desc  Tipo de archivo a enviar al dispositivo fisico
 */
export const TYPE_PANEL_SEND = 'Multiplex';

/**
 * @constant
 * @desc Caracteres Máximos permitidos
 */
export const MAX_CHARACTERS: number = 16;

/**
 * @constant
 * @desc Organización de los dispositivos
 */
export const DEVICE_ORDER: Array<string> = ['TEC P22', 'TEC P33', 'TEC P22T', 'TEC P12T', 'TEC P12TP', 'TEC P7T', 'TEC P10', 'AIO 1625 TEC', 'AIO 1625E TEC', 'TEC P10LC', 'TEC P12', 'TEC P4',  'MUX M30', 'MUX M17', 'MUX M16', 'MUX M10', 'MUX M17LC', 'MUX M10LC', 'AIO 1625 MOD', 'AIO 1625E MOD', 'IFI MUX', 'MUX PLATAFORMA', 'MUX MGE 1312',  'MUX HMI', 'MUX MGE 1312 V2', 'IFI MUX 8X32', 'MUX DOOR'];
//['TEC P22', 'TEC P10', 'AIO 1625 TEC', 'AIO 1625E TEC', 'AIO 1625 MOD', 'TEC P10LC', 'TEC P12', 'TEC P4', 'MUX M30', 'MUX M17', 'MUX M16', 'MUX M10', 'IFI MUX']

/**
 * @constant
 * @desc Carcateres Máx. permitidos en el dispositivo (Ejm: Nombre Entradas, Mensajes, Carrocería, etc.)
 */
export const MAX_CHARACTERS_IN_DEVICE: number = 16;